import { useEffect, useMemo, useState } from 'react';
import store from 'store2';
import { LocalStorageKey } from '../enums';
import { isAuthenticated, isLocalEnv } from '../utils';
import { useCountdownNew } from './useCountdownNew';
export const USE_COUNTDOWN_DEFAULT_VALUE = {
    countdown: '--:--',
    isSessionCountdownMsgOpened: false,
    isSessionExtendedMsgOpened: false,
    isSessionExtendable: false,
    handleSessionExtendClick: () => Promise.resolve(),
    handleSessionCountdownMsgClose: () => { },
    handleSessionExtendedMsgClose: () => { },
};
export const useCountdown = ({ platform, flags, }) => {
    const [countdownProps, setCountdownProps] = useState(USE_COUNTDOWN_DEFAULT_VALUE);
    /**
     * SessionTimeout feature is disabled only in two cases:
     * - 1: The customer is `NOT` logged-in
     * - 2: The current environment is `localhost` and the `localStorage` has this key `enable_local_session_timeout = true`
     */
    const isSessionTimeoutDisabled = useMemo(() => !isAuthenticated() ||
        (isLocalEnv() && store(LocalStorageKey.ENABLE_LOCAL_SESSION_TIMEOUT) !== true), []);
    const { countdown: countdownNew, isSessionCountdownMsgOpened: isSessionCountdownMsgOpenedNew, isSessionExtendedMsgOpened: isSessionExtendedMsgOpenedNew, isSessionExtendable, handleSessionExtendClick: handleSessionExtendClickNew, handleSessionCountdownMsgClose: handleSessionCountdownMsgCloseNew, handleSessionExtendedMsgClose: handleSessionExtendedMsgCloseNew, } = useCountdownNew({
        platform,
        disabled: isSessionTimeoutDisabled,
        flags,
    });
    useEffect(() => {
        if (isSessionTimeoutDisabled)
            return;
        setCountdownProps({
            countdown: countdownNew,
            isSessionCountdownMsgOpened: isSessionCountdownMsgOpenedNew,
            isSessionExtendable,
            isSessionExtendedMsgOpened: isSessionExtendedMsgOpenedNew,
            handleSessionExtendClick: handleSessionExtendClickNew,
            handleSessionCountdownMsgClose: handleSessionCountdownMsgCloseNew,
            handleSessionExtendedMsgClose: handleSessionExtendedMsgCloseNew,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSessionTimeoutDisabled,
        countdownNew,
        isSessionCountdownMsgOpenedNew,
        isSessionExtendable,
        isSessionExtendedMsgOpenedNew,
    ]);
    return countdownProps;
};
//# sourceMappingURL=useCountdown.js.map